import { render, staticRenderFns } from "./tjdzxxzyjsxy.vue?vue&type=template&id=3dcc2036&scoped=true&"
import script from "./tjdzxxzyjsxy.vue?vue&type=script&lang=js&"
export * from "./tjdzxxzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./tjdzxxzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tjdzxxzyjsxy.vue?vue&type=style&index=1&id=3dcc2036&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcc2036",
  null
  
)

export default component.exports